// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae952e83","455":"217f4cb5"}[chunkId] + ".chunk.js";
};